export const FETCH_SESSION = 'ORDERS/FETCH_SESSION';
export const FETCH_SESSION_SUCCESS = 'ORDERS/FETCH_SESSION_SUCCESS';
export const FETCH_SESSION_ERROR = 'ORDERS/FETCH_SESSION_ERROR';
export const LOGIN = 'ORDERS/LOGIN';
export const LOGIN_SUCCESS = 'ORDERS/LOGIN_SUCCESS';
export const LOGIN_ERROR = 'ORDERS/LOGIN_ERROR';
export const SET_HISTORY = 'ORDERS/SET_HISTORY';
export const SET_EMAIL = 'ORDERS/SET_EMAIL';